module.exports = {"540527100":"洛扎镇","540527101":"拉康镇","540527201":"扎日乡","540527202":"色乡","540527203":"生格乡","540527204":"边巴乡","540527205":"拉郊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540527.json
// module id = 2730
// module chunks = 0